import { BASE_URL } from "@utils/constants";
import {
  addAssignedFiles,
  addAssignedFolders,
  addAssignedProjects,
  addValidators,
  setSentenceTableData,
} from "@store/slices/validatorAdminSlice";
import apiClient from "@/services/api/apiClient";

export const fetchValidatorAdminProjects = (validatorAdminId) => async (dispatch) => {
  try {
    const data = await apiClient(
      BASE_URL + `api/validator-admin/structure/projects?validatorAdminId=${validatorAdminId}`
    );
    dispatch(addAssignedProjects(data));
    return data;
  } catch (error) {
    console.error("Error fetching validator admin projects:", error);
  }
};

export const fetchValidatorAdminFolders = (validatorAdminId, projectId) => async (dispatch) => {
  try {
    const data = await apiClient(
      BASE_URL + `api/validator-admin/structure/folders?validatorAdminId=${validatorAdminId}&projectId=${projectId}`
    );
    dispatch(addAssignedFolders(data));
    return data;
  } catch (error) {
    console.error("Error fetching validator admin folders:", error);
  }
};

export const fetchValidatorAdminFiles = (validatorAdminId, folderId) => async (dispatch) => {
  try {
    const data = await apiClient(
      BASE_URL + `api/validator-admin/structure/files?validatorAdminId=${validatorAdminId}&folderId=${folderId}`
    );
    dispatch(addAssignedFiles(data));
    return data;
  } catch (error) {
    console.error("Error fetching validator admin files:", error);
  }
};

// Thunk to fetch validator users by languageId
export const fetchValidatorUsersByLanguage = (languageId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token; // Assuming token is stored in auth slice

    console.log('[fetchValidatorUsersByLanguage] languageId:', languageId);

    if (!languageId) throw new Error('languageId is required');

    const data = await apiClient(
      BASE_URL + `api/validatorAdmin/getVU?languageId=${languageId}&validatorAdminId=${state.auth.userId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*',
          'Authorization': `Bearer ${token}`
        },
        credentials: "include",
      }
    );
    console.log('----------->[fetchValidatorUsersByLanguage] fetched users:', data.data);
    dispatch(addValidators(data.data)); // Assuming addValidators is an action to store fetched users
    console.log('[fetchValidatorUsersByLanguage] fetched users:', state.validatorAdmin.validators);
    return data.data;

  } catch (error) {
    console.error("Error fetching validator users:", error);
    throw error;
  }
};

export const fetchFileAssignmentDetails = ({ fileId, validatorAdminId }) => async (dispatch, getState) => {
  const state = getState();
  const token = state.auth.token;
  try {
    const data = await apiClient(
      BASE_URL + `api/validatorAdmin/filesByFileId?fileId=${fileId}&validatorAdminId=${validatorAdminId}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*',
          'Authorization': `Bearer ${token}`
        },
        credentials: "include",
      }
    );
    return data.data && data.data[0];
  } catch (error) {
    console.error('Error fetching file assignment details:', error);
    return null;
  }
};

export const fetchSentenceTableDataValidatorAdmin = ({ fileId, sourceId, targetId, validatorAdminId, clickReject }) => async (dispatch, getState) => {
  const state = getState();
  const token = state.auth.token;
  const url = clickReject ? `api/validatorAdmin/rejectedSentences?fileId=${fileId}&sourceId=${sourceId}&targetId=${targetId}&validatorAdminId=${validatorAdminId}` : `api/validatorAdmin/sentences?fileId=${fileId}&sourceId=${sourceId}&targetId=${targetId}&validatorAdminId=${validatorAdminId}`
  try {
    const data = await apiClient(
      BASE_URL + url,
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept': '*/*',
          'Authorization': `Bearer ${token}`
        },
        credentials: "include",
      }
    );
    if (data.status === 'success') {
      dispatch(setSentenceTableData(data.data));
    } else {
      dispatch(setSentenceTableData([]));
    }
    return data.data;
  } catch (error) {
    console.error('Error fetching sentence table data:', error);
    dispatch(setSentenceTableData([]));
    return [];
  }
};
